import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookmarkX } from "lucide-react";
import { fetchArticles, getBookmarks } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";

export default function BookmarksPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = getBookmarks();
    fetchArticles()
      .then((all) => setArticles(all.filter((a) => saved.includes(a.id))))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="pt-32 pb-16 max-w-7xl mx-auto px-4 sm:px-6" data-testid="bookmarks-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="mb-12 border-b border-white/10 pb-8">
        <span className="font-mono-meta text-xs text-[#FFD400] uppercase tracking-[0.3em]">आपकी लाइब्रेरी</span>
        <h1 className="font-display text-4xl sm:text-5xl text-white mt-3">सहेजे गए लेख</h1>
        <p className="font-mono-meta text-xs text-slate-500 mt-3">{articles.length} लेख सहेजे गए</p>
      </motion.div>
      {loading ? (
        <div className="py-20 text-center font-mono-meta text-xs text-slate-500 uppercase tracking-widest">लोड हो रहा है...</div>
      ) : articles.length === 0 ? (
        <div className="py-20 text-center">
          <BookmarkX size={40} className="mx-auto text-slate-600 mb-4" />
          <p className="text-slate-400">अभी तक कोई लेख सहेजा नहीं गया।</p>
          <Link to="/" className="text-[#FFD400] font-mono-meta text-sm mt-4 inline-block hover:underline">← खबरें पढ़ें और बुकमार्क करें</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <ArticleCard key={a.id} article={a} index={i} />
          ))}
        </div>
      )}
    </main>
  );
}
